<section class="b-tracker-email-list__section">
  <aad-delivery-tracker-status [deliveryTracker]="deliveryTracker()" />
</section>

<section class="b-tracker-email-list__section">
  <aad-delivery-tracker-documents [deliveryTracker]="deliveryTracker()" />
</section>

<section class="b-tracker-email-list__section">
  <div
    class="b-tracker-email-list__header"
    *transloco="let t; prefix: 'organizations.detailPage.riskAnalysisDeliveryTab.communication'"
  >
    <h3 class="b-tracker-email-list__title">{{ t('title') }}</h3>
  </div>

  <aml-filter />

  <aml-datatable
    [dataSource]="emails()"
    [columns]="tableColumns()"
    [hasMore]="false"
    [isLoading]="loading()"
    [showToolbar]="false"
    (queryParamsChange)="loadDataFromServer($event)"
  />
</section>
